import React from "react";
import { ResultColumns } from "./columnNames/NozzleColumns";
import { compactTableProps, greyTable } from "../../../../../../styles/muiProps";
import { useFieldArray, useFormContext } from "react-hook-form";
import {MaterialReactTable} from "material-react-table";

const ResultTable = (props) => {
  const { isLoading, isError } = props;
  const { control } = useFormContext();
  const { fields: resultFields } = useFieldArray({
    control,
    name: "DataGridView3",
  });

  return (
    <MaterialReactTable
      columns={ResultColumns ?? []}
      data={resultFields ?? []}
      {...compactTableProps}
      {...greyTable}
      enableSorting={false}
      defaultColumn={{ minSize: 20, size: 40 }}
      enableColumnActions={false}
      muiToolbarAlertBannerProps={
        isError
          ? {
              color: "error",
              children: "Calculation failed. Please check Input Data",
            }
          : undefined
      }
      state={{
        isLoading,
        showAlertBanner: isError,
      }}
      muiTableHeadCellProps={({ cell }) => ({
        sx: {
          borderRight: "1px solid var(--pv-table-border)",
          backgroundColor: "var(--pv-table-header-bg)",
          // fontSize: "16px",
          // display: "flex",
          // alignItems: "center",
          // px: 0,
          pt: 2,
          height: "95px",
          "& .Mui-TableHeadCell-Content-Wrapper": {
            whiteSpace: "normal",
            justifyContent: "center",
          },
        },
      })}
      muiEditTextFieldProps={({ cell }) => ({
        sx: {
          "& .MuiInputBase-input": {
            padding: "8.5px 8px",
            textAlign: "center",

            borderRight: "1px solid var(--pv-table-border)",
          },
        },
      })}
    />
  );
};

export default ResultTable;
